import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react"; import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

import CREATE_HONORARIO, { adaptAddHonorarioInput } from '../../../data/graphQL/mutations/Honorarios/createHonorario';
import GET_HONORARIO_DETALLE, { adaptHonorario } from '../../../data/graphQL/queries/Honorarios/getHonorarioDetalle';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { Box, CircularProgress, Grid } from '@mui/material';
import { GroupedContainer } from '../../ContratosCreation/components/GroupedContainer';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';
import adaptFiguraProfesionalArray, { GET_ALL_FIGURA_PROFESIONAL } from '../../../data/graphQL/queries/Honorarios/getFigurasProfesional';
import { GET_TIPO_MODULO } from '../../../data/graphQL/queries/TipoModulo/queries';
import { adaptTipoModuloArray } from '../../../adapters/tipoModuloAdapter';
import adaptClasificacionesMonitoreoArray, { GET_ALL_CLASIFICACIONES_MONITOREO } from '../../../data/graphQL/queries/Honorarios/getClasificacionesMonitoreo';
import adaptFormasLiquidacionArray, { GET_ALL_FORMAS_LIQUIDACION } from '../../../data/graphQL/queries/Honorarios/getFormaLiquidacion';
import UPDATE_HONORARIO from '../../../data/graphQL/mutations/Honorarios/updateHonorario';
import InputProgramas from './InputProgramas';
import { parsedCurrency } from '../../../utils/mathUtils';
import moment from 'moment';

const idUsuarioLoggeado = sessionStorage.getItem('idUsuario');
const IDS_TIPOS_ENFERMERIAS = [2, 7];

const IDS_FIGURAS_EXCLUIDAS = [5, 7, 8];

const ID_TIPO_PROFESIONAL_MEDICO = 1;
const ID_TIPO_PROFESIONAL_ENFERMERO = 2;

const FORMA_LIQUIDACION_SERVICIO = 1;
const FORMA_LIQUIDACION_VISITA = 2;

const ID_FIGURA_CONSULTOR = 2;
const ID_FIGURA_ESPECIALISTA = 4;

export const HonorarioCreationContent = ({ setChildrenAction }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    idHonorario,
    isNew,
    allowedWrite,
    delegaciones,
    tipoProfesionales
  } = location.state;

  const [figurasProfesional, setFigurasProfesional] = useState([]);
  const [clasificacionesMonitoreo, setClasificacionesMonitoreo] = useState([]);
  const [formasLiquidacion, setFormasLiquidacion] = useState([]);

  const [programas, setProgramas] = useState([]);
  const [honorarioFormData, setHonorarioFormData] = useState({
    valor: 0,
    valorVirtual: 0,
    valorExtra: 0,
    cambioSonda: 0,
    capacitacion: 0,
    emergencia: 0,
    extraduracion: 0,
    activo: true
  });

  const { data: dataFiguraProfesional } = useQuery(GET_ALL_FIGURA_PROFESIONAL);

  useEffect(() => {
    if (!dataFiguraProfesional) return;
    const adaptedFiguras = adaptFiguraProfesionalArray(dataFiguraProfesional)?.filter((figura) => figura.displayName !== 'Reemplazo' && figura.displayName !== 'Urgencia');
    setFigurasProfesional(adaptedFiguras);
  }, [dataFiguraProfesional]);

  const { data: dataClasificacionesMonitoreo } = useQuery(GET_ALL_CLASIFICACIONES_MONITOREO);

  useEffect(() => {
    if (!dataClasificacionesMonitoreo) return;
    setClasificacionesMonitoreo(adaptClasificacionesMonitoreoArray(dataClasificacionesMonitoreo));
  }, [dataClasificacionesMonitoreo]);

  const { data: dataFormasLiquidacion } = useQuery(GET_ALL_FORMAS_LIQUIDACION);

  useEffect(() => {
    if (!dataFormasLiquidacion) return;
    setFormasLiquidacion(adaptFormasLiquidacionArray(dataFormasLiquidacion));
  }, [dataFormasLiquidacion]);

  const [getProgramas, { data: dataProgramas, loading: programasLoading }] = useLazyQuery(GET_TIPO_MODULO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataProgramas) return;
    setProgramas(adaptTipoModuloArray(dataProgramas));
  }, [dataProgramas]);

  const [getHonorario, { data: dataHonorarios, loading: getLoading }] = useLazyQuery(GET_HONORARIO_DETALLE, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataHonorarios) return;
    if (!dataHonorarios?.honorarioProfesionalById) return toast.error('No se pudo cargar la información del honorario, intentelo nuevamente más tarde.');
    setHonorarioFormData(adaptHonorario(dataHonorarios?.honorarioProfesionalById));
  }, [dataHonorarios]);

  const [createHonorarioProfesional, { loading: createLoading }] = useMutation(CREATE_HONORARIO);
  const [updateHonorario, { loading: updateLoading }] = useMutation(UPDATE_HONORARIO);

  const saveLoading = useMemo(() => createLoading || updateLoading, [createLoading, updateLoading]);
  const saveDisabled = useMemo(() => !allowedWrite, [allowedWrite]);
  const esEnfermeria = useMemo(() => IDS_TIPOS_ENFERMERIAS.includes(honorarioFormData.idTipoProfesional), [honorarioFormData.idTipoProfesional]);

  const pageLoading = useMemo(() => getLoading || programasLoading, [getLoading, programasLoading]);

  const handleChange = useCallback((name, value) => {
    if (name === 'idTipoProfesional') {
      handleChange('idFiguraProfesional', 0);
    }
    setHonorarioFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  }, []);

  const renderInputGroups = useMemo(() => {
    const delegacionesFiltradas = delegaciones?.filter((x) => x.displayName !== 'TODAS');
    const figurasProfesionalesFiltradas = figurasProfesional.filter((x) => x.idTipoProfesional === honorarioFormData.idTipoProfesional && !IDS_FIGURAS_EXCLUIDAS.includes(x.id));

    return structuredClone(inputGroups).map((inputGroup) => {
      return {
        ...inputGroup,
        fields: inputGroup.fields.map((input) => {
          const updatedInput = { ...input };
          switch (input.name) {
            case 'usuario':
              break;
            case 'idDelegacion':
              updatedInput.disabled = !isNew;
              updatedInput.options = delegacionesFiltradas;
              break;
            case 'idTipoProfesional':
              updatedInput.disabled = !isNew;
              updatedInput.options = tipoProfesionales;
              break;
            case 'idFiguraProfesional':
              updatedInput.disabled = !isNew;
              updatedInput.options = figurasProfesionalesFiltradas;
              break;
            case 'idFormaLiquidacion':
              updatedInput.options = formasLiquidacion;
              if (!!honorarioFormData.idTipoProfesional && honorarioFormData.idTipoProfesional === ID_TIPO_PROFESIONAL_MEDICO)
                honorarioFormData.idFormaLiquidacion = FORMA_LIQUIDACION_SERVICIO; else
                if (!!honorarioFormData.idTipoProfesional && honorarioFormData.idTipoProfesional !== ID_TIPO_PROFESIONAL_MEDICO)
                  honorarioFormData.idFormaLiquidacion = FORMA_LIQUIDACION_VISITA;
              break;
            case 'idClaseMonitoreo':
              updatedInput.options = clasificacionesMonitoreo;
              updatedInput.hidden = honorarioFormData.idTipoProfesional === ID_TIPO_PROFESIONAL_MEDICO && (
                !honorarioFormData.idFiguraProfesional ||
                honorarioFormData.idFiguraProfesional === ID_FIGURA_CONSULTOR ||
                honorarioFormData.idFiguraProfesional === ID_FIGURA_ESPECIALISTA);

              if (updatedInput.hidden) handleChange('idClaseMonitoreo', null);
              break;
            case 'programa':
              updatedInput.options = programas;
              break;
            default:
              break;
          }
          if (!allowedWrite) {
            updatedInput.disabled = true;
          }
          return updatedInput;
        })
      };
    }
    );
  }, [
    allowedWrite,
    delegaciones,
    idUsuarioLoggeado,
    tipoProfesionales,
    figurasProfesional,
    formasLiquidacion,
    clasificacionesMonitoreo,
    programas,
    honorarioFormData.idTipoProfesional,
    honorarioFormData.idFiguraProfesional]
  );

  const validateStage = () => {
    const errorMessages = [];

    /* Validaciones de campos requeridos simples*/
    const requiredFields = [
      { value: honorarioFormData.descripcion?.trim(), message: 'Debe ingresar una descripción.\n' },
      { value: honorarioFormData.idDelegacion, message: 'Debe seleccionar una delegación.\n' },
      { value: honorarioFormData.idsTipoModulo?.length, message: 'Debe seleccionar al menos un programa.\n' },
      { value: honorarioFormData.idTipoProfesional, message: 'Debe seleccionar un tipo de profesional.\n' },
      { value: honorarioFormData.idFormaLiquidacion, message: 'Debe seleccionar una forma de liquidación.\n' },
      { value: honorarioFormData.fechaExpira, message: 'Debe ingresar una fecha expiración.\n' }
    ];

    requiredFields.forEach(field => {
      if (!field.value) errorMessages.push(field.message);
    });

    /* Validación condicional de figura profesional*/
    if (!honorarioFormData.idFiguraProfesional &&
      honorarioFormData.idTipoProfesional === ID_TIPO_PROFESIONAL_MEDICO) {
      errorMessages.push('Debe seleccionar una figura de profesional.\n');
    }

    /* Validación condicional de clasificación de monitoreo*/
    const figuraNoRequiereClasificacion =
      honorarioFormData.idFiguraProfesional === ID_FIGURA_CONSULTOR ||
      honorarioFormData.idFiguraProfesional === ID_FIGURA_ESPECIALISTA;

    if (!honorarioFormData.idClaseMonitoreo && !figuraNoRequiereClasificacion) {
      errorMessages.push('Debe seleccionar una clasificación de monitoreo.\n');
    }

    /* Validaciones de valores numéricos*/
    const numericValidations = [
      { value: honorarioFormData.valor, message: 'Debe ingresar un valor presencial.\n', allowZero: false },
      { value: honorarioFormData.valorVirtual, message: 'Debe ingresar un valor virtual.\n', allowZero: true },
      { value: honorarioFormData.valorExtra, message: 'Debe ingresar un valor extra.\n', allowZero: true }
    ];

    numericValidations.forEach(validation => {
      const parsedValue = parsedCurrency(validation.value);
      if (isNaN(parsedValue) || (!validation.allowZero && parsedValue <= 0)) {
        errorMessages.push(validation.message);
      }
    });

    /* Validación de fecha*/
    if (honorarioFormData.fechaExpira) {
      const fechaExpira = new Date(honorarioFormData.fechaExpira);
      if (isNaN(fechaExpira.getTime())) {
        errorMessages.push('Debe ingresar una fecha de expiración válida.\n');
      }

      if (moment(honorarioFormData.fechaExpira).isBefore(moment(), 'day')) {
        errorMessages.push('La fecha de expiración debe ser mayor o igual a hoy.\n');
      }
    }

    /* Validaciones específicas de enfermería*/
    if (esEnfermeria) {
      const enfermeriaFields = [
        { value: honorarioFormData.cambioSonda, message: 'Debe ingresar valor para cambio de sonda.\n' },
        { value: honorarioFormData.capacitacion, message: 'Debe ingresar valor para capacitación.\n' },
        { value: honorarioFormData.emergencia, message: 'Debe ingresar valor para emergencia.\n' },
        { value: honorarioFormData.extraduracion, message: 'Debe ingresar valor para extraduración.\n' }
      ];

      enfermeriaFields.forEach(field => {
        if (isNaN(parsedCurrency(field.value))) {
          errorMessages.push(field.message);
        }
      });
    }

    if (errorMessages.length > 0) {
      toast.error(errorMessages.join(' '));
      return false;
    }

    return true;
  };

  const handleSave = async () => {
    if (!validateStage()) return;

    const adaptedData = adaptAddHonorarioInput(honorarioFormData, esEnfermeria);

    if (isNew) {
      const { data } = await createHonorarioProfesional({
        variables: { input: adaptedData }
      });
      const { success, error } = data.createHonorarioProfesional;
      if (!success) {
        toast.error(error);
        return;
      }
      toast.success('Honorario creado con éxito.');
      navigate(`/honorarios/adminHonorarios`);
    } else {
      const { data } = await updateHonorario({
        variables: {
          input: adaptedData,
          idHonorarioProfesional: honorarioFormData.id
        }
      });
      const { success, error } = data.updateHonorarioProfesional;
      if (!success) {
        toast.error(error);
        return;
      }
      toast.success('Honorario actualizado con éxito.');
      navigate(`/honorarios/adminHonorarios`);
    }
  };

  useEffect(() => {
    if (!idHonorario || isNew) return;
    getHonorario({ variables: { idHonorarioProfesional: idHonorario } });
  }, [idHonorario]);

  useEffect(() => {
    if (!setChildrenAction) return;
    setChildrenAction(() =>
      <div className='header-actions-calidad'>
        {idHonorario > 0 && <div className='chip-estado-calidad'>
          <p>Id de Honorario: <strong>{idHonorario}</strong></p>
        </div>}
        <div className='top-buttons'>
          {allowedWrite &&
            <CustomButton
              label='Guardar'
              onClick={handleSave}
              isLoading={saveLoading}
              disabled={saveDisabled}
              variant='contained' />

          }
        </div>
      </div>
    );
  }, [setChildrenAction, allowedWrite, idHonorario, honorarioFormData, saveLoading]);

  useEffect(() => {
    if (!programasLoading) {
      getProgramas();
    }
  }, []);

  if (pageLoading) return <Box
    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh' }}>

    <CircularProgress size={40} />
  </Box>;

  return (
    <div>
      <Grid container spacing={2}>
        {renderInputGroups.
          filter((g) => g.name !== 'Enfermería' || g.name === 'Enfermería' && esEnfermeria).
          map((group, index) =>
            <GroupedContainer
              ungrouped={!group.name}
              sectionTitle={group.name}
              key={index}>

              <Grid container spacing={2} size={{ xs: 100 }}>
                {group.fields.map((field, fieldIndex) => {
                  return (
                    !field.hidden &&
                    <Grid key={`group_${index}-field_${fieldIndex}`} size={{ xs: field.col > 12 ? 100 : 12, sm: field.col > 12 ? 50 : field.col === 12 ? 12 : 6, lg: field.col }}>
                      {field.name !== 'idsTipoModulo' && <RenderInputByTypeMobile
                        input={field}
                        handleChange={handleChange}
                        value={honorarioFormData[field.name]} />
                      }
                      {field.name === 'idsTipoModulo' && <InputProgramas
                        options={programas}
                        handleChangeProgramas={(value) => handleChange(field.name, value)}
                        programas={honorarioFormData[field.name]}
                        disabled={field.disabled} />
                      }
                    </Grid>);

                })}
              </Grid>
            </GroupedContainer>
          )
        }
      </Grid>
    </div>);

};

const inputGroups = [
  {
    fields: [
      {
        displayName: "Descripción",
        name: "descripcion",
        required: true,
        type: "string",
        col: 4
      },
      {
        displayName: "Delegación",
        name: "idDelegacion",
        required: true,
        type: "select",
        col: 4
      },
      {
        displayName: "",
        name: "divider",
        type: "item",
        col: 4
      },
      {
        displayName: "Tipo profesional",
        name: "idTipoProfesional",
        required: true,
        type: "select",
        col: 3
      },
      {
        displayName: "Figura profesional",
        name: "idFiguraProfesional",
        required: true,
        type: "select",
        col: 3
      },
      {
        displayName: "Forma liquidación",
        name: "idFormaLiquidacion",
        required: true,
        disabled: true,
        type: "select",
        col: 3
      },
      {
        displayName: "Clasificación monitoreo",
        name: "idClaseMonitoreo",
        required: true,
        type: "select",
        col: 3
      },
      {
        displayName: "Valor Presencial",
        name: "valor",
        required: true,
        min: 0,
        type: "currency",
        col: 1.5
      },
      {
        displayName: "Valor Virtual",
        name: "valorVirtual",
        required: true,
        min: 0,
        type: "currency",
        col: 1.5
      },
      {
        displayName: "Valor Extra",
        name: "valorExtra",
        required: true,
        min: 0,
        type: "currency",
        col: 1.5
      },
      {
        displayName: "Fecha expira.",
        name: "fechaExpira",
        disablePast: true,
        required: true,
        type: "date",
        col: 1.8
      },
      {
        displayName: "Activo",
        name: "activo",
        required: true,
        type: "custom_switch",
        col: 1.5
      }]

  },
  {
    name: 'Enfermería',
    fields: [
      {
        displayName: "Cambio de sonda",
        name: "cambioSonda",
        required: false,
        min: 0,
        type: "currency",
        col: 25
      },
      {
        displayName: "Capacitación",
        name: "capacitacion",
        required: false,
        min: 0,
        type: "currency",
        col: 25
      },
      {
        displayName: "Urgencia",
        name: "emergencia",
        required: false,
        min: 0,
        type: "currency",
        col: 25
      },
      {
        displayName: "Extraduración",
        name: "extraduracion",
        required: false,
        min: 0,
        type: "currency",
        col: 25
      }]

  },
  {
    fields: [
      {
        displayName: "Observación",
        name: "observacion",
        required: false,
        type: "long_string",
        col: 12
      },
      {
        displayName: "Programa",
        name: "idsTipoModulo",
        required: true,
        type: "idsTipoModulo",
        col: 12
      }]

  }];